import React from 'react';

export interface FieldContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  Component?: React.ComponentType<{ field_id: string; isFastFill?: boolean }>;
  rightComponent?: React.ReactNode;
  showRightComponent?: boolean;
  field_id?: string;
  isFastFill?: boolean;
}

const FieldContainer = ({
  children,
}: FieldContainerProps) => {

  return <div className="w-full py-3">{children}</div>;
}

export default FieldContainer;
